import { PureComponent } from 'react';
import { Select } from 'antd';
import axios from 'axios';
import { requestWithAuth } from '../../services/api';

interface AidOrgSuggestProps {
  value?: {
    label: string;
    value: string | number;
  };
  disabled?: boolean;
  onChange?: (value: { label: string; value: string | number }) => void;
}

interface AidOrgData {
  id: string | number;
  organization_name: string;
}

interface AidOrgSuggestState {
  data: AidOrgData[];
  value?: { label: string; value: string | number };
  loading: boolean;
}

const { Option } = Select;
let source;
class AidOrgSuggest extends PureComponent<
  AidOrgSuggestProps,
  AidOrgSuggestState
> {
  constructor(props: AidOrgSuggestProps) {
    super(props);
    this.state = {
      data: [],
      value: props.value,
      loading: false,
    };
  }

  handleSearch = (searchValue: string) => {
    if (searchValue) {
      this.setState({ loading: true });
      const params = {
        organization_name: searchValue,
        page_size: 50,
      };

      if (source) source.cancel('Operation canceled by the user.');
      const { CancelToken } = axios; // eslint-disable-line import-x/no-named-as-default-member
      source = CancelToken.source();

      setTimeout(() => {
        requestWithAuth(
          'vault-aid-organization',
          'GET',
          params,
          null,
          source.token,
        )
          .then((response) => {
            if (response && response.results) {
              this.setState({ data: response.results, loading: false });
            } else {
              this.setState({ loading: false });
            }
          })
          .catch((e) => {
            console.log(e);
            this.setState({ loading: false });
          });
      }, 500);
    } else {
      this.setState({ data: [], loading: false });
    }
  };

  handleChange = (value) => {
    const { onChange } = this.props;
    if (onChange) onChange(value);
    this.setState({ value });
  };

  render() {
    const { data, value, loading } = this.state;
    return (
      <Select
        style={{ width: '100%' }}
        showSearch
        labelInValue
        loading={loading}
        value={value}
        placeholder="Search AidOrg"
        defaultActiveFirstOption={false}
        showArrow={false}
        filterOption={false}
        onSearch={this.handleSearch}
        onChange={this.handleChange}
        notFoundContent={null}
        allowClear
        disabled={this.props.disabled}
      >
        {data &&
          data.length > 0 &&
          data.map((item) => {
            return <Option key={item.id}>{item.organization_name}</Option>;
          })}
      </Select>
    );
  }
}
export default AidOrgSuggest;
